export const allowedKeys = [
  'Backspace',
  'ArrowLeft',
  'ArrowRight',
  'Tab',
  'Enter',
  'Escape',
];

export const offsetMinutes = 330; // converting GMT to IST, we use an offset of 5 hours and 30 minutes, which equals 330 minutes

export const LENGTH = {
  MAX_LENGTH_TWO: 2,
  MAX_LENGTH_THREE: 3,
  MAX_LENGTH_TEN: 10,
};

export const iconSizeInRem = 1.2
